module.exports = __webpack_public_path__ + "img/logo-text.5ea55255.png";